import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, MessageCircle, Facebook, Linkedin } from "lucide-react";
import './PrivacyPolicy.css';
import nobg from "../assets/images/noBG logo.png";

export default function PrivacyPolicy() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="privacy-root" dir="rtl">
            <nav className="privacy-nav">
                <div className="privacy-container nav-container">
                    <Link to="/">
                        <img src={nobg} alt="أمانك - Amanak" className="navbar-logo-img" />
                    </Link>
                    <Link to="/" className="back-home-link">
                        <ArrowRight size={20} />
                        الرجوع للرئيسية
                    </Link>
                </div>
            </nav>

            <main className="privacy-main">
                <div className="privacy-container content-container">
                    <header className="privacy-header">
                        <h1>سياسة الخصوصية</h1>
                        <p className="last-updated">آخر تحديث: 1 يناير 2026</p>
                    </header>

                    <section className="privacy-intro">
                        <p>
                            مقدمة: نحن في فريق "أمانك" ندرك أن البيانات التي سنحصل عليها هي سرك التجاري. لذلك تم صياغة هذه السياسة لنضمن لك أعلى درجات الأمان والشفافية.
                        </p>
                    </section>

                    <div className="policy-grid">
                        <article className="policy-section">
                            <h2>أولاً: نوع المعلومات المجمعة</h2>
                            <ul>
                                <li><strong>معلومات التسجيل:</strong> الاسم، البريد الإلكتروني، رقم الهاتف، أسم المخزن أو المحل</li>
                                <li><strong>البيانات التشغيلية:</strong> أسم العميل تفاصيل المنتجات، التكلفة، أسعار البيع، وسعر الصرف المدخل يدوياً.</li>
                                <li><strong>بيانات الجهاز:</strong> نوع الجهاز ونظام التشغيل لتحسين تجربة الاستخدام وحل المشاكل التقنية.</li>
                            </ul>



                            <h2>ثانياً: استخدام المعلومات</h2>
                            <p>
                                في نظام المخازن يتم عرض كافة التفاصيل التي تريدها لكل معاملة في أي مكان حسب رغبتك اما في نظام المبيعات يقوم النظام بمعالجة الأرقام المالية لحساب ربحك وتكاليفك وإعطائك تقارير مفصله وربط سعر الدولار بأسعار منتجاتك إذا أردت ذلك، وكله يتم في خوادمنا لضمان إظهار النتائج الدقيقة لك. وعليه يتم إستخدام بياناتك لتشغيل النظام وتقديم الدعم الفني وتحسين تجربة المستخدم.
                            </p>



                            <h2>ثالثاً: مشاركة البيانات</h2>
                            <p>
                                لا يتم كشف أو نشر أو مشاركة أي معلومات لأي طرف ثالث دون موافقة كتابية مسبقة من طرفك، ولكن في حال طالبت أي جهة قانونية رسمية مختصة عبر خطاب موثق ذلك، سيتم وقتها مشاركة بياناتك وسيتم إخطارك بذلك أيضاً.
                            </p>



                            <h2>رابعاً: حماية وتخزين البيانات</h2>
                            <p>
                                يتم تخزين بياناتك على خوادم سحابية مؤمنة (Secure Cloud Servers) ، ونلتزم بإتخاذ كافة التدابير التقنية والتنظيمية المناسبة لحماية بياناتك من الوصول غير المصرح به، التعديل أو الإفصاح غير القانوني، الفقدان أو الإتلاف.
                            </p>



                            <h2>خامساً: حدود المسؤولية</h2>
                            <p>
                                بينما نتخذ أقصى التدابير الأمنية، يقع على عاتقك مسؤولية الحفاظ على سرية "كلمة المرور" الخاصة بحسابك، وعدم منح صلاحيات دخول لموظفين غير مخولين بذلك.
                            </p>


                            <h2>سادساً: حقوق المستخدم</h2>
                            <p>
                                يحق للمستخدم الإطلاع علي بياناته الشخصية، تعديل أو تحديث بياناته، طلب حذف مخزنه او محله أو اي حساب أوبيانات مرتبطه به.
                            </p>



                            <h2>سابعاً: التعديلات على السياسة</h2>
                            <p>
                                قد نقوم بتحديث هذه السياسة لتواكُب التطورات التقنية. سنقوم بإشعارك داخل النظام أو برسالة واتساب في رقمك المسجل بطرفنا في حال وجود أي تغيير جوهري.
                            </p>


                            <h2>ثامناً: التواصل معنا</h2>
                            <p>فريق الدعم الفني في أمانك متاح دائماً عبر وسائل التواصل الإجتماعي:</p>
                            <ul className="contact-links">
                                <li>
                                    <a href="https://api.whatsapp.com/message/STKXQTAFDC37A1?autoload=1&app_absent=0" target="_blank" rel="noopener noreferrer">
                                        <MessageCircle size={20} />
                                        واتساب
                                    </a>
                                </li>
                                <li>
                                    <a href="https://web.facebook.com/profile.php?id=61586860653173" target="_blank" rel="noopener noreferrer">
                                        <Facebook size={20} />
                                        فيسبوك
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.linkedin.com/company/amanak/" target="_blank" rel="noopener noreferrer">
                                        <Linkedin size={20} />
                                        لينكد إن
                                    </a>
                                </li>
                            </ul>
                        </article>
                    </div>
                </div>
            </main>

            <footer className="privacy-footer">
                <div className="privacy-container">
                    <p>© {new Date().getFullYear()} أمانك (Amanak). جميع الحقوق محفوظة.</p>
                </div>
            </footer>
        </div>
    );
}
